import { createFileRoute } from '@tanstack/react-router';
import CircuitCreate from '~/containers/CircuitCreate';

export const Route = createFileRoute('/circuits/new')({
  component: CircuitCreate,
  validateSearch(search): { from?: string } {
    return {
      from: (search.from as string) || undefined,
    };
  },
});
